import React, { useEffect } from "react";
import "./Form.css";
import { Helmet } from "react-helmet";
const Form = () => {
  // useEffect(() => {
  //   const inputs = document.querySelectorAll('input[data-isrequired="true"]');
  //   if (inputs) {
  //     const interval = setInterval(() => {
  //       console.log("hi");
  //       inputs.forEach((input) => {
  //         input.style.borderTop = "red";
  //         input.classList.remove("ff-input-type");
  //       });
  //     }, 1000);
  //     return () => clearInterval(interval);
  //   }
  // }, []);

  // useEffect(() => {
  //   document.addEventListener('DOMContentLoaded', function() {
  //     // Select the input element
  //     var inputElement = document.querySelector('input[name="Case.AccountId.LastName"]');
  
  //     // Check if the element does not contain the 'ff-input-type-invalid' class
  //     if (inputElement && !inputElement.classList.contains('ff-input-type-invalid')) {
  //       inputElement.classList.add('no-error');
  //         console.log('The input element does not contain the ff-input-type-invalid class.');
  //     } else if (inputElement) {
  //         console.log('The input element contains the ff-input-type-invalid class.');
  //     } else {
  //         console.log('The input element was not found.');
  //     }
  //   });
  // }, []);

  return (
    <>
      <div className="contact-page-content-de">
        <div className="d-flex justify-content-center align-items-center mt-4 mt-md-2 mt-lg-0">
          <div className="de-form-text">
            <div className="form-header ms-3 ms-md-1 ms-lg-3">
              <h2 className="mb-3">kontakt</h2>
            </div>
            <p className="text-center" style={{ marginBottom: "30px" }}>
              <span></span>Du kannst uns gerne über den Live-Chat kontaktieren,
              oder uns unter 04231-944409 anrufen.
            </p>
            <p className="text-center">
              Wir sind werktags zwischen 9 und 19 Uhr verfügbar.
            </p>
            <p>&nbsp;</p>
            <p className="text-center" style={{ marginTop: "30px" }}>
              <span>
                James Wellbeloved ist eine Abteilung von Direct2Pet Europe B.V.
                mit eingetragenem Sitz: Direct2Pet Europe B.V., Taylorweg 5,
                5466AE Veghel, Niederlande. Registrierungsnummer: 819782610.
              </span>
            </p>
          </div>
        </div>
      </div>
      <Helmet>
        {/* <style>
          {`
        .ff-input-type .ff-input-type-invalid:active{
        border: red !important;}
        `}
        </style> */}
        <script
          type="text/javascript"
          id="jsFastForms"
          src="https://sfapi.formstack.io/FormEngine/Scripts/Main.js?d=RUZTrbciR-liPoiMn4MQJF8IYi0f7bwL9KtFGyEBjrJQb8r_Z96LqIknAAzU9NQb"
        ></script>
      </Helmet>
      <div className="d-md-flex justify-content-center align-items-center">
        <div id="dvFastForms"></div>
      </div>
    </>
  );
};

export default Form;
